import React from 'react';

const DriverTerms = () => {
  return (
    <div className="bg-[#F6F7F8]">
      <div className="container mx-auto py-12 text-gray-800">
        <div className="max-w-4xl mx-auto bg-white my-16 p-6 md:p-10 rounded-lg">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-center">
            Conditions Générales d'Utilisation – Livreurs OuiGoo
          </h1>
          <p className="text-center text-gray-500 mb-8">
            Dernière mise à jour : 1er juillet 2025
          </p>

          <p className="mb-6">
            En accédant à la plateforme OuiGoo et en créant volontairement votre compte Livreur, vous acceptez expressément et sans réserve les présentes Conditions Générales d'Utilisation (CGU), ainsi que notre Politique de Confidentialité et notre Charte de Conduite.
          </p>
          <p className="mb-8 font-semibold bg-yellow-100 p-3 rounded-md">
            Veuillez lire attentivement ces conditions car elles contiennent des informations importantes concernant vos droits, obligations et recours juridiques.
          </p>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Objet et Nature du Service</h2>
            <p className="mb-4">
              OuiGoo agit en tant que plateforme technologique d'intermédiation connectant les Clients et les Livreurs indépendants via une application mobile.
            </p>
            <div className="bg-orange-50 border-l-4 border-primary-custom p-4 mb-4">
              <p className="font-semibold mb-2">IMPORTANT :</p>
              <ul className="list-disc list-inside space-y-2 pl-4">
                <li>OuiGoo NE FOURNIT PAS de services de livraison et n'agit PAS en tant que transporteur</li>
                <li>Tous les services de livraison sont fournis par des prestataires indépendants</li>
                <li>Les Livreurs ne sont PAS des employés, agents ou représentants d'OuiGoo</li>
                <li>Les Livreurs sont SEULS RESPONSABLES des services qu'ils fournissent</li>
              </ul>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Définitions</h2>
            <div className="space-y-3">
              <div>
                <h3 className="font-semibold text-lg">Livreur</h3>
                <p className="text-gray-700">Professionnel indépendant souhaitant offrir un service de livraison via l'Application OuiGoo.</p>
              </div>
              <div>
                <h3 className="font-semibold text-lg">Application Livreur</h3>
                <p className="text-gray-700">Logiciel mobile permettant aux Livreurs d'accéder aux services OuiGoo.</p>
              </div>
              <div>
                <h3 className="font-semibold text-lg">Société</h3>
                <p className="text-gray-700">Ozinex, éditeur de la plateforme OuiGoo.</p>
              </div>
              <div>
                <h3 className="font-semibold text-lg">Client</h3>
                <p className="text-gray-700">Toute personne demandant un service de livraison.</p>
              </div>
              <div>
                <h3 className="font-semibold text-lg">Course</h3>
                <p className="text-gray-700">Trajet effectué par le Livreur et enregistré dans l'Application.</p>
              </div>
              <div>
                <h3 className="font-semibold text-lg">Frais de Service</h3>
                <p className="text-gray-700">Commission perçue par la Société en contrepartie des Services fournis.</p>
              </div>
              <div>
                <h3 className="font-semibold text-lg">Portefeuille Électronique</h3>
                <p className="text-gray-700">Porte-monnaie électronique sur lequel s'effectuent les transactions financières.</p>
              </div>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Inscription et Compte Livreur</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">Conditions d'inscription</h3>
            <p className="mb-4">Pour vous inscrire en tant que Livreur, vous devez :</p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Être majeur (18 ans minimum)</li>
              <li>Avoir la capacité juridique de contracter</li>
              <li>Fournir des informations vraies, exactes et complètes</li>
              <li>Disposer d'un appareil compatible avec l'Application</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">Création du compte</h3>
            <p className="mb-4">
              L'inscription se fait gratuitement via l'Application en remplissant le formulaire prévu à cet effet. Vous devez choisir un nom d'utilisateur et un mot de passe qui sont strictement personnels et non transférables.
            </p>
            <p className="font-semibold bg-yellow-100 p-3 rounded-md">
              Vous vous engagez à ne pas divulguer vos identifiants et à ne pas permettre l'accès à votre compte à un tiers. Vous serez seul responsable de toute utilisation de votre compte.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Documents Obligatoires</h2>
            <p className="mb-4">Pour créer votre compte Livreur et utiliser le Service, vous devez fournir les documents suivants :</p>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">Documents obligatoires</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li><strong>Pièce d'identité valide</strong> (carte d'identité nationale, passeport ou permis de conduire)</li>
              <li><strong>Preuve de résidence</strong> (facture d'électricité, d'eau, de téléphone ou attestation de domicile datant de moins de 3 mois)</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">Document facultatif</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li><strong>Registre de Commerce / IFU</strong> (Identifiant Fiscal Unique)</li>
            </ul>

            <p className="mt-4 font-semibold bg-blue-50 p-3 rounded-md">
              Vous devez également disposer d'un véhicule en bon état de fonctionnement (moto, scooter, vélo, etc.) et d'une assurance valide pour ce véhicule.
            </p>
            
            <p className="mt-4 text-sm text-gray-600">
              OuiGoo se réserve le droit de vérifier ces documents à tout moment et de suspendre votre compte en cas de non-conformité ou de documents frauduleux.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Utilisation du Service</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">Obligations du Livreur</h3>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Maintenir votre véhicule en bon état de fonctionnement</li>
              <li>Respecter le code de la route et toutes les lois applicables</li>
              <li>Traiter les Clients avec courtoisie et professionnalisme</li>
              <li>Livrer les colis dans les délais impartis</li>
              <li>Manipuler les marchandises avec soin</li>
              <li>Respecter les consignes de livraison spécifiées par le Client</li>
              <li>Porter une tenue appropriée et professionnelle</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3">Interdictions</h3>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Sous-traiter ou déléguer vos courses à un tiers</li>
              <li>Utiliser l'Application à des fins frauduleuses ou illégales</li>
              <li>Harceler, menacer ou discriminer les Clients</li>
              <li>Demander des pourboires de manière insistante</li>
              <li>Utiliser les données des Clients à des fins personnelles</li>
              <li>Modifier ou altérer l'Application</li>
            </ul>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Responsabilité</h2>
            <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
              <p className="font-semibold mb-2">VOUS ÊTES SEUL RESPONSABLE :</p>
              <ul className="list-disc list-inside space-y-2 pl-4">
                <li>De la bonne exécution du service de livraison</li>
                <li>De tout dommage matériel (colis endommagé, perte de marchandise)</li>
                <li>De tout dommage immatériel (retard, erreur de destination)</li>
                <li>De tout dommage corporel (accident, blessure)</li>
              </ul>
            </div>
            <p className="mb-4">
              Votre assurance responsabilité civile professionnelle doit couvrir tous ces risques. OuiGoo ne pourra en aucun cas être tenu responsable des dommages causés lors d'une course.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Rémunération et Frais de Service</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">Tarification</h3>
            <p className="mb-4">
              Le prix de chaque course est déterminé par OuiGoo en fonction de plusieurs paramètres : distance, temps de trajet, type de véhicule, créneau horaire, et autres facteurs applicables.
            </p>

            <h3 className="text-xl font-semibold mb-3">Commission</h3>
            <p className="mb-4">
              Une commission est facturée pour chaque course effectuée. Le montant de cette commission est calculé en pourcentage du prix de la course et est communiqué directement dans l'Application.
            </p>
            <p className="font-semibold bg-yellow-100 p-3 rounded-md mb-4">
              VOUS RECONNAISSEZ EXPRESSÉMENT ET SANS RÉSERVE DEVOIR PAYER LES FRAIS LIÉS AU SERVICE.
            </p>

            <h3 className="text-xl font-semibold mb-3">Programmes incitatifs</h3>
            <p className="mb-4">
              OuiGoo peut mettre en place des programmes d'incitation sur des périodes définies, offrant des bonus financiers ou en nature aux Livreurs atteignant des objectifs prédéfinis.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Modalités de Paiement</h2>
            <p className="mb-4">
              Pour les services de livraison fournis aux Clients, vous pouvez être payé :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>En espèces par le Client</li>
              <li>Via le Portefeuille Électronique du Client</li>
            </ul>
            <p className="mb-4">
              Lorsqu'un Client paie via son Portefeuille Électronique OuiGoo, votre Portefeuille Électronique est crédité du même montant.
            </p>
            <p className="mb-4">
              Toutes les transactions financières liées à l'utilisation du Service sont effectuées sur votre Portefeuille Électronique. Vous acceptez expressément qu'OuiGoo puisse déduire de votre Portefeuille toute somme due pour l'utilisation du Service.
            </p>
            <p className="font-semibold bg-blue-50 p-3 rounded-md">
              Vous vous engagez à maintenir votre portefeuille avec un solde positif et pouvez à tout moment retirer les fonds via les moyens mis à disposition par OuiGoo.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">9. Politique d'Annulation</h2>
            <p className="mb-4">
              L'annulation de courses affecte la fiabilité et la qualité du service. Bien que vous puissiez annuler une réservation, cette annulation doit respecter les conditions indiquées dans l'Application.
            </p>
            <p className="mb-4">
              OuiGoo se réserve le droit de :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Facturer des frais d'annulation à votre Portefeuille</li>
              <li>Appliquer des pénalités en cas d'annulations répétées sans raison valable</li>
              <li>Suspendre votre compte en cas d'abus</li>
            </ul>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">10. Réglementation Fiscale et Sociale</h2>
            <p className="mb-4">
              En tant que professionnel indépendant, vous déclarez :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Respecter la législation fiscale et sociale en vigueur</li>
              <li>Être à jour de vos cotisations et déclarations liées à votre activité</li>
              <li>Être responsable de vos propres obligations fiscales et sociales</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              OuiGoo ne retient aucune charge sociale ou fiscale. Vous êtes seul responsable de vos déclarations et paiements auprès des administrations compétentes.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">11. Protection des Données Personnelles</h2>
            <p className="mb-4">
              La protection de vos données personnelles est une priorité pour OuiGoo. Pour connaître en détail comment nous collectons, utilisons et protégeons vos données, veuillez consulter notre <a href="/driver-privacy-policy" className="text-primary-custom hover:underline font-semibold">Politique de Confidentialité pour Livreurs</a>.
            </p>
            <p className="font-semibold bg-blue-50 p-3 rounded-md">
              En utilisant le Service, vous consentez expressément à ce que vos données de géolocalisation soient partagées avec les Clients pour permettre le suivi en temps réel de leurs livraisons.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">12. Confidentialité</h2>
            <p className="mb-4">
              Vous vous engagez à considérer comme confidentielles et à ne pas utiliser sans l'accord préalable d'OuiGoo les informations suivantes :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Les données personnelles des Clients</li>
              <li>Les informations commerciales d'OuiGoo</li>
              <li>Les secrets commerciaux et savoir-faire</li>
              <li>Les processus, produits et stratégies d'OuiGoo</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              Cette obligation de confidentialité perdurera pendant deux ans après la fin du présent contrat.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">13. Limitation de Responsabilité</h2>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <p className="font-semibold mb-2">LE SERVICE EST FOURNI "EN L'ÉTAT" ET "TEL QUE DISPONIBLE".</p>
              <p className="mb-4">
                OuiGoo ne garantit pas que le Service fonctionnera sans interruption ni erreur. Nous ne sommes pas responsables :
              </p>
              <ul className="list-disc list-inside space-y-2 pl-4">
                <li>Des pannes d'infrastructure Internet ou télécommunications</li>
                <li>Des cas de force majeure</li>
                <li>Des interruptions temporaires pour maintenance</li>
                <li>Des pertes de profits ou dommages indirects</li>
              </ul>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">14. Résiliation</h2>
            
            <h3 className="text-xl font-semibold mb-3 mt-6">À votre initiative</h3>
            <p className="mb-4">
              Vous pouvez résilier le présent contrat à tout moment et sans motif, en donnant un préavis écrit de sept (7) jours via l'Application. Toutes les sommes dues à OuiGoo seront alors immédiatement exigibles.
            </p>

            <h3 className="text-xl font-semibold mb-3">À l'initiative d'OuiGoo</h3>
            <p className="mb-4">OuiGoo peut résilier ce contrat sans préavis et bloquer votre accès si :</p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-6">
              <li>Vous avez commis un manquement grave à vos obligations</li>
              <li>Vous avez violé les lois applicables ou les droits de tiers</li>
              <li>Votre comportement met en danger la sécurité d'OuiGoo ou de tiers</li>
            </ul>

            <p className="mb-4">OuiGoo peut résilier ce contrat avec un préavis de sept (7) jours si :</p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Vous avez reçu de manière répétée de mauvaises évaluations</li>
              <li>OuiGoo reçoit des plaintes avérées concernant votre prestation</li>
            </ul>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">15. Statut Indépendant</h2>
            <p className="font-semibold bg-orange-50 p-4 rounded-md">
              Aucune relation de partenariat, d'employeur-employé ou de mandat n'existe entre vous et OuiGoo du fait du présent contrat. Vous opérez en tant que professionnel indépendant.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">15. Modifications des CGU</h2>
            <p className="mb-4">
              OuiGoo se réserve le droit de modifier les présentes CGU à tout moment. Vous serez informé de toute modification via l'Application.
            </p>
            <p className="mb-4">
              La poursuite de l'utilisation du Service après la date d'entrée en vigueur des modifications vaudra acceptation des CGU révisées.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">16. Loi Applicable et Juridiction</h2>
            <p className="mb-4">
              Tout litige pouvant naître de l'exécution ou de l'interprétation du présent contrat sera réglé à l'amiable.
            </p>
            <p className="mb-4">
              À défaut d'accord, le litige sera réglé selon les règles de droit de votre lieu de résidence par le tribunal ayant compétence en matière commerciale.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">17. Contact</h2>
            <p className="mb-4">Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter :</p>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="font-semibold">Ozinex</p>
              <p>Service OuiGoo</p>
              <p><a href="mailto:hello@ouigoo.co" className="text-primary-custom hover:underline">hello@ouigoo.co</a></p>
              <p><a href="https://ouigoo.co" target="_blank" rel="noopener noreferrer" className="text-primary-custom hover:underline">ouigoo.co</a></p>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-center">Questions Fréquentes</h2>
            
            <div className="space-y-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Q: OuiGoo est-elle une entreprise de transport ?</h3>
                <p className="text-gray-700">R: Non, OuiGoo n'est pas une entreprise de transport. Nous vous connectons avec des personnes demandant des services de livraison et vous permettons de suivre votre activité. Vous êtes le prestataire de transport.</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Q: Quelqu'un d'autre peut-il utiliser mon compte ?</h3>
                <p className="text-gray-700">R: Non, votre compte est strictement personnel. C'est une garantie de sécurité pour la plateforme et les Clients.</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Q: Quel est le montant de la commission ?</h3>
                <p className="text-gray-700">R: Après chaque course, vous pouvez voir directement dans l'Application le montant de la commission facturée. Le pourcentage varie selon le type de course.</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Q: Où sont mes gains quand le client ne paie pas en espèces ?</h3>
                <p className="text-gray-700">R: Les gains de vos courses sont versés dans votre Portefeuille Électronique. Vous pouvez les consulter dans votre compte et en disposer à tout moment.</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Q: Puis-je refuser une réservation ?</h3>
                <p className="text-gray-700">R: Oui, mais si vous effectuez trop de refus sans raison valable, OuiGoo pourra vous imposer des pénalités ou suspendre votre compte.</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Q: Comment contacter le support en cas de difficulté ?</h3>
                <p className="text-gray-700">R: Vous pouvez contacter le service d'assistance via l'Application. Ce service est disponible 24h/24 et 7j/7.</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Q: Suis-je un employé d'OuiGoo ?</h3>
                <p className="text-gray-700">R: Non, vous opérez sur la plateforme en tant que Prestataire de Transport Indépendant. Vous n'êtes pas un employé, agent ou représentant d'OuiGoo.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DriverTerms;
